import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast !bg-white !text-slate-900 !border-slate-200 shadow-xl",
          title: "!text-slate-900 !font-semibold",
          description: "!text-slate-600",
          error: "!bg-rose-50 !text-rose-800 !border-rose-200",
          success: "!bg-emerald-50 !text-emerald-800 !border-emerald-200",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
